/* tslint:disable */

/**
 */
export class EquipGenZone {
    BOTTOM_PRM3?: number;
    ID_EQUIP_GEN_ZONE?: number;
    ZONE_NUMBER?: number;
    TEMP_SENSOR?: number;
    TOP_ADIABAT?: number;
    BOTTOM_ADIABAT?: number;
    LEFT_ADIABAT?: number;
    RIGHT_ADIABAT?: number;
    FRONT_ADIABAT?: number;
    REAR_ADIABAT?: number;
    TOP_CHANGE?: number;
    TOP_PRM1?: number;
    TOP_PRM2?: number;
    TOP_PRM3?: number;
    BOTTOM_CHANGE?: number;
    BOTTOM_PRM1?: number;
    BOTTOM_PRM2?: number;
    ID_EQUIPGENERATION?: number;
    LEFT_CHANGE?: number;
    LEFT_PRM1?: number;
    LEFT_PRM2?: number;
    LEFT_PRM3?: number;
    RIGHT_CHANGE?: number;
    RIGHT_PRM1?: number;
    RIGHT_PRM2?: number;
    RIGHT_PRM3?: number;
    FRONT_CHANGE?: number;
    FRONT_PRM1?: number;
    FRONT_PRM2?: number;
    FRONT_PRM3?: number;
    REAR_CHANGE?: number;
    REAR_PRM1?: number;
    REAR_PRM2?: number;
    REAR_PRM3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equip-gen-zone.ts